import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Features } from '../components/sections/Features';
import { SocialProof } from '../components/sections/SocialProof';
import { ProblemSolution } from '../components/sections/ProblemSolution';
import { CourseDetails } from '../components/sections/CourseDetails';
import { FooterCTA } from '../components/sections/FooterCTA';
export function Landing() {
  return <main className="min-h-screen bg-bg-primary text-text-primary" data-id="element-269">
      <Hero data-id="element-270" />
      <Features data-id="element-271" />
      <SocialProof data-id="element-272" />
      <ProblemSolution data-id="element-273" />
      <CourseDetails data-id="element-274" />
      <FooterCTA data-id="element-275" />
    </main>;
}